<app-split-pane
  storageKey="split.compliance"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.compliance.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="complianceSuggestions" [context]="complianceContext" placeholder="Ask about compliance tasks..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="compliance.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.compliance.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Compliance</h2>
            <p class="text-muted mb-3">
              Track security obligations and verify evidence readiness for audits.
            </p>
            <h3 class="h5 mb-3">Security Compliance Review</h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Framework</label>
                <select class="form-select" [(ngModel)]="complianceDraft.framework">
                  <option value="">Select framework...</option>
                  @for (option of frameworkOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Data classification</label>
                <select class="form-select" [(ngModel)]="complianceDraft.dataClassification">
                  <option value="">Select classification...</option>
                  @for (option of dataClassificationOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Evidence notes</label>
                <textarea
                  class="form-control"
                  rows="3"
                  [(ngModel)]="complianceDraft.evidenceNotes"
                  placeholder="Control ownership, evidence links, and residual risks..."
                ></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="validatingCompliance" (click)="runComplianceCheck()">
                @if (validatingCompliance) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Checking...
                } @else {
                  Run Compliance Check
                }
              </button>
            </div>
            @if (complianceError) {
              <div class="alert alert-danger mt-3 mb-0">{{ complianceError }}</div>
            }
            @if (complianceSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ complianceSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Security Posture Summary</h3>
            @if (!hasValidated) {
              <div class="small text-muted">No review completed yet. Run the compliance check to populate this summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Framework</div>
                  <div class="summary-value">{{ complianceDraft.framework }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Data classification</div>
                  <div class="summary-value">{{ complianceDraft.dataClassification }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Evidence notes</div>
                  <div class="summary-value">{{ complianceDraft.evidenceNotes.trim() || 'No notes provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="compliance.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
